module.exports = __webpack_public_path__ + "static/media/img_media.bc772bac.jpg";